export enum SESSION_GROUPS_ENDPOINTS {
	BASE = 'session_groups'
}

export enum ASSIGNED_PROGRAMS_ENDPOINTS {
	BASE = 'assigned_programs'
}
